import styled from "styled-components";
import { tokens } from "../../../../public/tokens";

const { colors, globals } = tokens;

// Base looks every `<Domain>Label` builds on; labels only pass colours (see ../README.md).

/** Tinted pill with uppercase text, e.g. module status "DRAFT". */
export const StyledPillLabel = styled.span(({ $bg = "transparent", $fg = colors.text.primary }) => ({
    display: "inline-block",
    padding: globals["spacing-0-5"],
    borderRadius: "4px",
    background: $bg,
    color: $fg,
    fontSize: "0.8em",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
}));

/** Coloured text with a leading dot in the same colour, e.g. a school or qualification type. */
export const StyledDotLabel = styled.span(({ $color = colors.text.secondary }) => ({
    display: "inline-flex",
    alignItems: "baseline",
    gap: globals["spacing-1"],
    color: $color,

    "&::before": {
        content: '""',
        width: globals["spacing-2"],
        height: globals["spacing-2"],
        flexShrink: 0,
        borderRadius: "50%",
        background: "currentColor",
    },
}));
